import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

const TONE = {
  success: "kpi-border-success",
  warning: "kpi-border-warning",
  critical: "kpi-border-critical",
  primary: "kpi-border-primary",
  ai: "kpi-border-ai",
  muted: "kpi-border-muted",
};

export default function KpiCard({ label, value, tone = "primary", delta, sub, icon: Icon, testId, to, onClick }) {
  const deltaPositive = typeof delta === "number" && delta >= 0;
  const clickable = !!(to || onClick);
  const Wrapper = to ? Link : "div";
  const wrapperProps = to ? { to } : (onClick ? { onClick, role: "button", tabIndex: 0 } : {});
  return (
    <Wrapper
      {...wrapperProps}
      data-testid={testId}
      className={`block bg-card border border-border rounded-sm p-5 ${TONE[tone]} ${clickable ? "cursor-pointer hover:border-primary/50 hover:shadow-sm transition-all" : ""}`}
    >
      <div className="flex items-start justify-between">
        <div className="label-mono">{label}</div>
        {Icon && <Icon className="w-4 h-4 text-muted-foreground" strokeWidth={1.5} />}
      </div>
      <div className="mt-3 font-heading text-[28px] font-light tracking-tight tabular leading-none">
        {value}
      </div>
      <div className="mt-3 flex items-center gap-2 text-[11px] text-muted-foreground">
        {typeof delta === "number" && (
          <span className={`inline-flex items-center gap-0.5 font-medium ${
            deltaPositive ? "text-[hsl(var(--success))]" : "text-[hsl(var(--critical))]"
          }`}>
            {deltaPositive ? <ArrowUpRight className="w-3 h-3" /> : <ArrowDownRight className="w-3 h-3" />}
            {Math.abs(delta).toFixed(1)}%
          </span>
        )}
        {sub && <span className="truncate">{sub}</span>}
      </div>
    </Wrapper>
  );
}
